<template>
    <div class="account-page" style="height: 100vh;">
   <!-- Main Wrapper -->
   <div class="main-wrapper">
    <div class="account-content">

        <div class="container">

            <!-- Account Logo -->
            <div class="account-logo">
                <router-link to="/index"><img src="@/assets/img/dkl.png" alt="Datenschutzkanzlei Lenz"></router-link>
            </div>
            <!-- /Account Logo -->

            <Loader v-show="!promiseFinished" />
            <div class="account-box">
                <div class="account-wrapper">
                    <h3 class="account-title">Mandant Wählen</h3>
                    <p class="account-subtitle">Zugriff auf Mandant DSMS Tool</p>

                    <!-- Account Form -->
                    <div class="">
                      <label v-if="errors.length" class="text-danger">
                        <ul class="list-unstyled">
                          <li v-for="error in errors">{{error}}</li>
                        </ul>
                      </label>
                    </div>
                      <div class="form-group">
                          <label>Mandant</label>
                        <select id="mandanten_list"></select>
                      </div>
                      <div class="form-group text-center">
                          <button class="btn btn-primary account-btn" type="button" @click="setMandant">Weiter</button>
                      </div>
                    <!-- /Account Form -->

                </div>
            </div>
        </div>
    </div>
</div>
<!-- /Main Wrapper -->
</div>
<!-- /Main Wrapper -->
</template>
<script>
import {mapActions, mapMutations} from 'vuex'
import {baseURL, crmURL, service, serviceRequest} from '@/utils/request.js';
import {getDepartments, getSystems, getDataTypes, getPersonGroups, getSuppliers} from "@/utils";
import Loader from "@/components/loader.vue";

  export default {
    components: {Loader},
    data() {
      return {
        errors: [],
        mandant: null,
        mandant_select : null,
        mandant_id : null,
        mandantCRMID : null,
        mandantName : null,
        promiseFinished: false,
      }
    },
    mounted() {
      if ($('#mandanten_list').length > 0) {
        this.getMandantenSelection()
      }
    },
    methods: {
      ...mapActions(['fetchAccountByShortName']),
      async setMandant(e) {
        e.preventDefault()
        this.mandant = this.mandant_select.select2('data')[0].text
        this.mandant_id = this.mandant_select.select2('data')[0].id
        this.mandantName = this.mandant_select.select2('data')[0].text
        await service.request({
          url: `${crmURL}/company_by_name/?name=` + encodeURIComponent(this.mandantName),
          method: 'GET',
          responseType: 'json',
        }).then(response => {
          this.$store.commit('SET_ACCOUNT', {
            id: this.mandant_id,
            name: this.mandant,
            address: response.data.company_detail.address,
            betreuer: response.data.company_detail.consultant,
            betriebsrat: response.data.company_detail.betriebsrat,
            email: response.data.company_detail.email,
            website: response.data.company_detail.website,
            dsb: response.data.company_detail.dsb,
            phone: response.data.company_detail.phone,
            restSubscription: null,
            crmID: response.data.company_detail.id,
            dsko: response.data.company_detail.dsko,
            aufsichtsbehoerde: response.data.company_detail.aufsichtsbehoerde,
            aiEnabled: response.data.company_detail.ai_enabled,
          })
        })
        await getSystems(this.mandant_id)
        await getDepartments(this.mandant_id)
        await getDataTypes(this.mandant_id)
        await getPersonGroups(this.mandant_id)
        await getSuppliers(this.mandant_id)
        this.$router.push({name: 'indexx'})

      },
      async getMandantenSelection() {
        service.request({
          url: '/todos/v1/accounts/',
          dataType: 'json',
          type: "GET",
        }).then((response) => {
          const selectData = []
          response.data.forEach((item) => {
            selectData.push({
              text: item.name,
              id: item.id,
              crm_id: item.crm_id,
            })
          })
          this.mandant_select = $('#mandanten_list').select2({
            minimumResultsForSearch: 2,
            width: '100%',
            placeholder: '---',
            data: selectData,
            language: 'de',
          })
          this.promiseFinished = true
        }).catch((error) => {
          console.log(error)
        })
      }
    }
  }
</script>
